import React from "react";
import PropTypes from "prop-types";
import { Text, Image } from "./base/index";
import info from "../images/info.png";
import warning from "../images/warning.png";
import criticalWarning from "../images/warning-high.png";
import { debugLog } from "../utils/index";

const ICONS = Object.freeze({
  info,
  warning,
  criticalWarning,
});

const Callout = ({ type, text, className = "", fullWidth = false }) => {
  const callOutCriticalWarningStyles =
    type && typeof type === "string" && type === "criticalWarning" && fullWidth
      ? {
          backgroundColor: "#ffefec",
          border: "2px solid #fecdc4",
        }
      : {};
  debugLog(`Callout fullWidth ${type}`, fullWidth);
  if (
    type &&
    typeof type === "string" &&
    (type === "info" || type === "warning" || type === "criticalWarning") &&
    text &&
    typeof text === "string" &&
    text !== "" &&
    text !== " "
  ) {
    return (
      <div
        className={`bg-gray-1 flex items-center ${
          fullWidth ? "fullWidth" : ""
        } rounded px-6 py-4 ${className}`}
        style={{ ...callOutCriticalWarningStyles, pageBreakInside: "avoid" }}
      >
        <Image
          image={{
            url: ICONS[type],
            width: 72,
            height: 72,
          }}
          forceWidth={24}
          className="mr-4"
        />
        <Text tag="p" className="flex-1">
          {text}
        </Text>
      </div>
    );
  }
  return <div />; // If type or text invalid or empty, display nothing
};

Callout.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
};

export default Callout;
